import React,{useState} from "react";
import { Box,Typography,FormGroup,InputBase,Button, TextareaAutosize } from "@material-ui/core";
import axios from "axios";
import MessagePopup from "../MessagePopup";

const {UPDATE_MAINSIDE_KITPAGE} = require("../../api/Kitpage/Main_side");

const Main_side = () => {
    const [openPopUp,setOpenPopUp] = useState(false);
    const [resp,setResp] = useState("");

    const [heading,setHeading] = useState("");
    const [subHeading,setSubHeading] = useState("");
    const [linkColumn,setLinkColumn] = useState("");
    const [linkName,setLinkName] = useState("");
    const [picturesLink,setPicturesLink] = useState("");

   const handleUpdate = () => {
        if(heading.length > 0 && subHeading.length > 0 && 
            picturesLink.length > 0 && linkName.length > 0 && linkName.length > 0){
            const new_Data = {
                heading: heading,
                subHeading: subHeading,
               linkColumn: linkColumn,
                linkName: linkName,
                picturesLink: picturesLink,
              }
              axios.put( UPDATE_MAINSIDE_KITPAGE,new_Data,{
                headers: {
                  Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                },
              })
              .then(response => {
                setResp("Uploaded Successfully");
                setOpenPopUp(true);
                setHeading(""); setSubHeading(""); setPicturesLink(""); setLinkColumn(""); setLinkName("");
              })
              .catch((err) => {
                setResp("Something error occured");
                setOpenPopUp(true);
              });
        } else {
            setResp("Kindly add all the details");
            setOpenPopUp(true);
        }
    }
    return ( 
        
        <Box style={fullPage}>
            <Box  width={450}>
                    <Typography variant="h5" component="h2" fontWeight='650' style={{color: '#fff'}}>
                        Form
                    </Typography>
                <Box sx={style}>
                    <FormGroup>
                        <TextareaAutosize
                            placeholder='Main heading'
                            minRows={2}
                            style={inputs}
                            value={heading}
                            onChange={(e) => setHeading(e.target.value)}
                        />
                        
                        <TextareaAutosize 
                            minRows={2}
                            placeholder='SubHeading' 
                            style={inputs}  
                            value={subHeading}
                            onChange={(e) => setSubHeading(e.target.value)}
                        />
                        
                        <InputBase 
                            placeholder='Link Column' 
                            style={inputs}
                            value={linkColumn}
                            onChange={(e) => setLinkColumn(e.target.value)}
                        /> 
                        <InputBase 
                            placeholder='Link Name' 
                            style={inputs}
                            value={linkName}
                            onChange={(e) => setLinkName(e.target.value)}
                        /> 
                        <InputBase 
                            placeholder='Picture Upload Link' 
                            style={inputs}
                            value={picturesLink}
                            onChange={(e) => setPicturesLink(e.target.value)}
                        /> 
                    </FormGroup>
                    <Box display='flex' justifyContent='center' >
                        <Button style={btn} size='large' onClick={handleUpdate}>Submit</Button>
                    </Box>
                </Box>
                
                <MessagePopup open={openPopUp} message={resp} handleAlertClose={() => setOpenPopUp(!openPopUp)}/>
            </Box>
    </Box>
);
}

const style = {
border: 'none',
boxShadow: 25,
textAlign: 'center',
color:'black',
boxSizing: 'content-box',
background: '#000',
p: 2,
borderRadius: 7,
};

const inputs ={
padding: 8,
marginTop: 7,
marginBottom: 7,
borderRadius: 5,
background: '#eee',
border: '1px solid #aaa',
}

const fullPage ={
width:'100%',
height:'90vh',
backgroundColor:'black',
display: 'flex',
justifyContent: 'center',
paddingTop: '2rem'
}

const btn={
color: '#000' ,
background: '#68F5D4' , 
marginTop: '10px'  , 
fontWeight: '650',
}
 
export default Main_side;